module.exports = __webpack_public_path__ + "img/battery-empty.edaec9db.svg";